import React, { useState, useEffect } from 'react';
import { Divider, Typography, useMediaQuery } from '@material-ui/core';
import parse from 'html-react-parser';

const Fade = require('react-reveal/Fade');

const ListTeknologiKami = ({ title, data, index, isId }: any) => {
  const matches = useMediaQuery('(max-width:1050px)');
  const [dataListTKState, setDataListTKState] = useState([]);

  const fetchListTK = async () => {
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content/tk/${data.id}`
    );
    const resJson = await res.json();
    setDataListTKState(resJson.data);
  };

  useEffect(() => {
    fetchListTK();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        padding: '6rem 0',
        margin: '0 auto',
        backgroundColor: index % 2 !== 0 ? '#ffff' : '#f0f0f0',
      }}
    >
      <Fade>
        <Typography
          color='textPrimary'
          variant='h4'
          align='center'
          gutterBottom
          style={{
            fontSize: 28,
          }}
        >
          {title}
        </Typography>
      </Fade>
      <Divider
        style={{
          display: 'block',
          width: 263,
          borderBottom: '5px solid #ba0008',
          marginBottom: 38,
        }}
      />
      {dataListTKState.map((row: any, index: number) => {
        return (
          <div
            key={row[isId ? 'title_id' : 'title_en']}
            style={{
              width: '100%',
              maxWidth: 1280,
              display: 'flex',
              flexDirection: matches
                ? index % 2
                  ? 'column-reverse'
                  : 'column'
                : index % 2
                ? 'row-reverse'
                : 'row',
              justifyContent: 'center',
              gap: '3rem',
              padding: '2rem 1rem',
            }}
          >
            {matches && index % 2 === 0 && (
              <Fade>
                <Typography
                  variant='h5'
                  color='primary'
                  style={{ marginBottom: -24, textTransform: 'uppercase' }}
                >
                  {row[isId ? 'title_id' : 'title_en']}
                </Typography>
              </Fade>
            )}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: 16,
              }}
            >
              {(JSON.parse(row.images) || []).map((image: any, i: number) => (
                <Fade key={image} delay={i * 500}>
                  <div style={{ width: 600, height: 450 }}>
                    <a
                      href={`${process.env.REACT_APP_URL}/images/${image}`}
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <img
                        src={`${process.env.REACT_APP_URL}/images/${image}`}
                        alt={image}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'contain',
                          objectPosition: '50% 50%',
                        }}
                      />
                    </a>
                  </div>
                </Fade>
              ))}
            </div>
            <Fade delay={dataListTKState.length * 500}>
              <div
                style={{
                  width: '100%',
                  maxWidth: 600,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                {((matches && index % 2 !== 0) || !matches) && (
                  <Typography
                    variant='h5'
                    color='primary'
                    style={{ textTransform: 'uppercase' }}
                    gutterBottom
                  >
                    {row[isId ? 'title_id' : 'title_en']}
                  </Typography>
                )}
                <div>{parse(row[isId ? 'content_id' : 'content_en'])}</div>
              </div>
            </Fade>
          </div>
        );
      })}
    </div>
  );
};

const TeknologiKami = ({ isId }: any) => {
  const [dataTKState, setDataTKState] = useState([]);

  const fetchTK = async () => {
    const res = await fetch(`${process.env.REACT_APP_URL}/api/jlp/content/tk`);
    const resJson = await res.json();
    setDataTKState(resJson.data);
  };

  useEffect(() => {
    fetchTK();
  }, []);

  return (
    <>
      <div
        style={{
          maxWidth: 1280,
          margin: '0 auto',
          padding: '0 16px',
          marginBottom: 32,
        }}
      >
        <Typography style={{ marginBottom: '4rem' }}>
          {isId ? 'Jalan Tol Kami' : 'Our Toll Road'}
          &nbsp; &gt; &nbsp;{' '}
          <span style={{ color: '#e3232a' }}>
            {isId ? 'Teknologi Kami' : 'Our Technology'}
          </span>
        </Typography>
        <Typography
          color='primary'
          variant='h4'
          style={{ marginBottom: '2rem' }}
        >
          {isId ? 'Teknologi Kami' : 'Our Technology'}
        </Typography>
      </div>
      {dataTKState.map((row: any, index) => (
        <ListTeknologiKami
          key={row.id}
          index={index}
          title={row[isId ? 'title_id' : 'title_en']}
          data={row}
          isId={isId}
        />
      ))}
    </>
  );
};

export default TeknologiKami;
